import {
  tFetchedPlace,
  tPickedPlace,
  tPlacePrediction,
  tPlaceSuggestion,
} from './GoogleMapsAction.types.ts';

/**
 * INT-1720 — the place search needs the Places API (New) on the Maps key, which
 * staging and production do not have yet, so it is off unless
 * VITE_LOCATION_PLACE_SEARCH_ENABLED is "true". Off, the picker is the map and
 * its pin, as before the ticket.
 */
export const LOCATION_PLACE_SEARCH_ENABLED =
  import.meta.env.VITE_LOCATION_PLACE_SEARCH_ENABLED === 'true';

/** Fewer characters match too much to be worth a request. */
export const PLACE_SEARCH_MIN_LENGTH = 3;
export const PLACE_SEARCH_DEBOUNCE_MS = 250;

/**
 * INT-1720 — the suggestions worth showing from an autocomplete answer. Only
 * place predictions carry a place we can send; query predictions do not.
 */
export function toPlaceSuggestions(
  suggestions: { placePrediction: tPlacePrediction | null }[],
): tPlaceSuggestion[] {
  return suggestions.flatMap((suggestion) => {
    const prediction = suggestion.placePrediction;
    if (!prediction) return [];
    return [
      {
        placeId: prediction.placeId,
        mainText: prediction.mainText?.text ?? prediction.text.text,
        secondaryText: prediction.secondaryText?.text ?? '',
        prediction,
      },
    ];
  });
}

/**
 * INT-1720 — the picked place from a fetched Place, or null when Google gave
 * no location (nothing to send) or no name (nothing more than a pin).
 */
export function toPickedPlace(place: tFetchedPlace): tPickedPlace | null {
  const name = place.displayName?.trim() ?? '';
  if (!place.location || !name) return null;
  return {
    place: { name, address: place.formattedAddress?.trim() ?? '' },
    location: { lat: place.location.lat(), lng: place.location.lng() },
  };
}
